export const ADD_SPECIAL_SSR_MODAL_DATA = 'ADD_SPECIAL_SSR_MODAL_DATA'

export default (passengerId: string, ssrId: string) => ({
  type: ADD_SPECIAL_SSR_MODAL_DATA,
  passengerId,
  ssrId,
})
